const radConfig = {
  allottement_status: false,
  currentUrl: "https://genx.aikenist.com/",
  previousVisitUrl: "https://medapps.medallcorp.in",
  baseUrl: "https://genx.aikenist.com/api/quickrad",
  baseUrlRadio: "https://genx.aikenist.com/api/quickrad/radio",
  radTitle: "AIkenist Technology Pvt. Ltd.",
  viewerURL: "https://genx.aikenist.com/aikenviewer/viewer/",
  viewer3DURL:"https://genx.aikenist.com/3daikenviewer/viewer?StudyInstanceUIDs=",
  viewerPET:"https://genx.aikenist.com/3daikenviewer/tmtv?StudyInstanceUIDs=",
  viewerSM:"https://genx.aikenist.com/3daikenviewer/microscopy?StudyInstanceUIDs=",  
  viewerSeg:"https://genx.aikenist.com/3daikenviewer/segmentation?StudyInstanceUIDs=",  
  viewerMultiple: "https://genx.aikenist.com/3daikenviewer/viewer?",
  viewerMultiplePet: "https://genx.aikenist.com/3daikenviewer/tmtv?",
  medDream:"https://genx.aikenist.com/?study=",
  thumbnailURL: "https://genx.aikenist.com/dicom-web/instances/",
  gifURL:
  "https://genx.aikenist.com/api/quickrad/general/convert-to-gif?series_ins=",
  dicomWeb: "https://genx.aikenist.com/dicom-web",
  weasisDicomWeb: "https://genx.aikenist.com/dicom-web",
  studyList: "https://genx.aikenist.com/dicom-web/studies",
  localViewer: "https://genx.aikenist.com/aikenviewer/local",
  client: "genx",
  paymentComplete: true,
  version: "v2.0",
  radiAntPath: "C:\\xampp\\htdocs\\python\\input_scan\\tmp"
};

// ******************************************

localStorage.setItem("client", radConfig.client);

if (
  localStorage.getItem("showTAT") == "" ||
  localStorage.getItem("showTAT") == null
) {
  localStorage.setItem("showTAT", "false");
}
if (
  localStorage.getItem("studyTracker") == "" ||
  localStorage.getItem("studyTracker") == null
) {
  localStorage.setItem("studyTracker", "false");
}

export default radConfig;
